(ns frontend.view.modals.change-pipeline.events)

(defn form-ready? [state]
  (let [{:keys [selected-stage-id selected-pipeline-id]} @state]
    (and selected-pipeline-id selected-stage-id)))
